import { render, staticRenderFns } from "./ViStudentPromote.vue?vue&type=template&id=b5cc689e"
import script from "./ViStudentPromote.vue?vue&type=script&lang=js"
export * from "./ViStudentPromote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports